function isShouldGetUsers({ state, output }) {
  if (state.get('users.approved')) {
    output.false()
  } else {
    output.true()
  }
}
isShouldGetUsers.outputs = ['true', 'false']

export default isShouldGetUsers



// WEBPACK FOOTER //
// ./src/modules/user/actions/isShouldGetUsers.js